import {RestService} from "@sinossi/mates-react-library";
import {SearchFilter} from "../models";

export class FavouriteServices {
    static getFavourite = (request: SearchFilter, callback: any, catchCallback: any) => {
        RestService
            .post(`/api/account/likes/filter`, request)
            .then(callback)
            .catch(catchCallback)
    }
}
